/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ConduitSettingsSpoolTagModule } from './conduit-settings-spool-tag.module';
export { ConduitSettingsSpoolTagComponent } from './conduit-settings-spool-tag.component';